import { CustomField, type CustomFieldConstructorData } from './CustomField'
import { CustomFieldTypes } from './CustomFieldTypes'

export interface CustomFieldValueConstructorData<T = string | boolean> {
  // NOTE: id and value are nullable to handle the case where the field was created after the entity it is associated
  // with was created. For example, if a user creates an Order and then creates a new type of CustomField, the Order
  // will not have a value for the new CustomField.
  id: Nullable<number>
  value: Nullable<T>
  field: CustomFieldConstructorData
}

export class CustomFieldValue<T = string | boolean> {
  id: Nullable<number>
  value: Nullable<T>
  field: CustomField

  constructor(data: CustomFieldValueConstructorData<T>) {
    this.id = data.id
    this.value = data.value
    this.field = new CustomField(data.field)
  }

  get isMissingRequiredValue(): boolean {
    return this.field.required && (this.value === null || this.value === '')
  }

  get isInvalidValue(): boolean {
    return (
      Boolean(this.value) &&
      this.field.type === CustomFieldTypes.DROPDOWN &&
      typeof this.value === 'string' &&
      !this.field.choices.includes(this.value)
    )
  }
}
